import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { ADMIN_ONLY_PATHS } from "./PermissionConfig";

const RequireAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [restrictedPages, setRestrictedPages] = useState([]);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await axios.get(`${window.backendUrl}/verify-token`, { withCredentials: true });
                setIsAuthenticated(true);
                setUserRole(res.data.role);

                // Handle restrictedPages parsing
                let restricted = res.data.restrictedPages;
                if (typeof restricted === 'string') restricted = JSON.parse(restricted);
                setRestrictedPages(restricted || []);

                console.log('Auth Checked. Role:', res.data.role);
            } catch (error) {
                console.log('Authentication failed:', error);
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) return <></>; // Loading

    if (!isAuthenticated) return <Navigate to="/" />;

    // --- ACCESS CHECK ---
    // 1. Admins are never restricted and can reach admin-only screens.
    if (userRole === 'admin') return <Outlet />;

    const currentPath = location.pathname;

    // 2. Admin-only screens (Manage Users, Manage Tasks Admin) are always
    //    blocked for non-admins. They're intentionally left out of
    //    APP_STRUCTURE, so under the default-allow model below nothing
    //    would ever restrict them otherwise.
    const isAdminOnly = ADMIN_ONLY_PATHS.some(p =>
        currentPath === p ||
        currentPath.startsWith(p + '/')
    );

    // 3. Everything else is allowed by default, UNLESS this admin
    //    explicitly restricted the current path for this user.
    const isRestricted = restrictedPages.some(p =>
        currentPath === p ||
        currentPath.startsWith(p + '/')
    );

    if (!isAdminOnly && !isRestricted) {
        return <Outlet />;
    } else {
        return (
            <div className="container mt-5 text-center">
                <h2 className="text-danger">Access Denied</h2>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }
};

export default RequireAuth;
